var ChipType = /* @__PURE__ */ ((ChipType2) => {
  ChipType2["Tag"] = "Tag";
  ChipType2["TagMark"] = "TagMark";
  ChipType2["TagMarkIcon"] = "TagMarkIcon";
  ChipType2["Status"] = "Status";
  ChipType2["StatusV2"] = "StatusV2";
  ChipType2["Mark"] = "Mark";
  ChipType2["Prefix"] = "Prefix";
  ChipType2["Workspace"] = "Workspace";
  ChipType2["Note"] = "Note";
  return ChipType2;
})(ChipType || {});
var ChipVariant = /* @__PURE__ */ ((ChipVariant2) => {
  ChipVariant2["Transparent"] = "transparent";
  ChipVariant2["Disabled"] = "disabled";
  ChipVariant2["Default"] = "default";
  ChipVariant2["DefaultReversed"] = "defaultReversed";
  ChipVariant2["LightBlue"] = "lightBlue";
  ChipVariant2["Blue"] = "blue";
  ChipVariant2["Bronze"] = "bronze";
  ChipVariant2["Green"] = "green";
  ChipVariant2["GreenDark"] = "greenDark";
  ChipVariant2["LightGreen"] = "lightGreen";
  ChipVariant2["Orange"] = "orange";
  ChipVariant2["OrangeDark"] = "orangeDark";
  ChipVariant2["Purple"] = "purple";
  ChipVariant2["Turquoise"] = "turquoise";
  ChipVariant2["Yellow"] = "yellow";
  ChipVariant2["Grey"] = "grey";
  ChipVariant2["LightGrey"] = "lightGrey";
  ChipVariant2["DarkGrey"] = "darkGrey";
  ChipVariant2["GreyInverted"] = "greyInverted";
  ChipVariant2["BronzeInverted"] = "bronzeInverted";
  ChipVariant2["Violet"] = "violet";
  ChipVariant2["Coffee"] = "coffee";
  ChipVariant2["DropdownDefault"] = "dropdownDefault";
  ChipVariant2["PrimaryButton"] = "primaryButton";
  ChipVariant2["Beige"] = "beige";
  ChipVariant2["Mint"] = "mint";
  ChipVariant2["YellowNeon"] = "yellowNeon";
  ChipVariant2["Burgundy"] = "burgundy";
  ChipVariant2["SkyBlue"] = "skyBlue";
  ChipVariant2["Pink"] = "pink";
  ChipVariant2["WarmYellow"] = "warmYellow";
  ChipVariant2["Red"] = "red";
  return ChipVariant2;
})(ChipVariant || {});
export {
  ChipType,
  ChipVariant
};
//# sourceMappingURL=types.js.map
